import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

export const CarouselSkeleton = () => {
  const placeholderSlides = new Array(4).fill(0); // Number of slides

  return (
    <div className="relative px-2 py-2">
      <Swiper
        slidesPerView={4}
        spaceBetween={10}
        breakpoints={{
          300: { slidesPerView: 1, spaceBetween: 10 },
          600: { slidesPerView: 2, spaceBetween: 10 },
          980: { slidesPerView: 3, spaceBetween: 10 },
          1280: { slidesPerView: 4, spaceBetween: 10 },
        }}
        style={{
          width: "100%",
          height: "auto",
        }}
      >
        {placeholderSlides.map((_, index) => (
          <SwiperSlide key={index}>
            <div
              className="flex flex-col bg-[#0D0D0D] rounded-sm animate-pulse"
              style={{
                height: "350px", // Match your actual card height
                overflow: "hidden",
              }}
            >
              {/* Image Placeholder */}
              <div
                className="bg-zinc-900"
                style={{
                  height: "200px", // Match your image height
                  width: "100%",
                }}
              />
              {/* Tags */}
              <div className="flex gap-1 p-2">
                {[1, 2, 3].map((tag) => (
                  <div
                    key={tag}
                    className="bg-zinc-800 rounded"
                    style={{ width: "50px", height: "14px" }}
                  />
                ))}
              </div>
              {/* Title */}
              <div
                className="bg-zinc-800 rounded mx-2 mb-2"
                style={{ height: "20px", width: "60%" }}
              />
              {/* Time and Button */}
              <div className="flex gap-2 mx-2">
                <div className="bg-zinc-800 rounded" style={{ width: "50px", height: "14px" }} />
                <div className="bg-zinc-800 rounded" style={{ width: "80px", height: "14px" }} />
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>

      {/* Navigation Arrows (Optional) */}
      <div
        className="absolute top-1/2 -translate-y-1/2 left-0 right-0 z-10 flex justify-between"
      >
        <div className="swiper-button-prev white-arrow"></div>
        <div className="swiper-button-next white-arrow"></div>
      </div>
    </div>
  );
};